import type {
  ListingPricingType,
  ListingPricingValues,
} from '@ha/api-v2/types/Listing';

import { getAllRelevantPrices } from './getAllRelevantPrices';

export const getPrecisePriceRange = ({
  pricingType,
  pricingValues,
  dateRange,
}: {
  pricingValues: ListingPricingValues;
  pricingType: ListingPricingType;
  dateRange?: {
    from: string | Date;
    to?: string | Date;
  };
}) => {
  if (!pricingValues?.precise) return null;

  const relevantPrices = getAllRelevantPrices({
    pricingType,
    pricingValues,
    dateFilter: dateRange,
  });

  if (!relevantPrices.length) return null;

  const from = Math.min(...relevantPrices);
  const to = Math.max(...relevantPrices);

  return {
    from,
    to,
    type: from === to ? ('flatPrice' as const) : ('fromPrice' as const),
  };
};
